<ape-drawer
  [visible]="visible"
  [title]="title"
  [position]="'right'"
  [closable]="true"
  [dismissible]="false"
  (closeClick)="onCancelClick()"
>
  <!-- Form Content -->
  <div class="flex flex-col gap-5 border-b-[1px] border-b-[var(--colors-gray-scale-gray-4)] pb-[20px]">

    <div class="w-full h-[1px] bg-[#EEEEEE]"></div>
    <div class="flex flex-row justify-between items-center w-full">
      <p class="text-[#000] text-[16px] font-normal leading-[24px]"><b>{{activeFiltersCount}}</b> {{
        activeFiltersCount === 1 ? (TRANSLATION_KEYS.admin.monitoring.ACTIVE_FILTER | translate) :
        (TRANSLATION_KEYS.admin.monitoring.ACTIVE_FILTERS | translate) }}</p>
      <p
        role="button"
        tabindex="0"
        class="text-[#0048D9] text-[16px] font-semibold leading-[16px] underline cursor-pointer"
        (click)="resetFiltersClick()"
      >{{ TRANSLATION_KEYS.admin.monitoring.RESET_FILTERS | translate }}</p>
    </div>
    <div class="w-full h-[1px] bg-[#EEEEEE]"></div>

    <!-- Stato Development plan -->
    <ape-multi-select
      *ngIf="developmentPlanStatusOptions.length>0"
      [id]="'development-plan-status-filter'"
      [label]="TRANSLATION_KEYS.admin.monitoring.DEVELOPMENT_PLAN_STATUS | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.monitoring.SELECT_STATUSES | translate"
      [options]="developmentPlanStatusOptions"
      [selectedOptions]="selectedDevelopmentPlanStatuses"
      (selectedOptionsChange)="onDevelopmentPlanStatusesChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <!-- Stato autoevaluazione -->
    <ape-multi-select
      *ngIf="selfAssessmentStatusOptions.length>0"
      [id]="'self-assessment-status-filter'"
      [label]="TRANSLATION_KEYS.admin.monitoring.SELF_ASSESSMENT_STATUS | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.monitoring.SELECT_STATUSES | translate"
      [options]="selfAssessmentStatusOptions"
      [selectedOptions]="selectedSelfAssessmentStatuses"
      (selectedOptionsChange)="onSelfAssessmentStatusesChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <!-- Stato valutazione -->
    <ape-multi-select
      *ngIf="evaluationStatusOptions.length>0"
      [id]="'evaluation-status-filter'"
      [label]="TRANSLATION_KEYS.admin.monitoring.EVALUATION_STATUS | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.monitoring.SELECT_STATUSES | translate"
      [options]="evaluationStatusOptions"
      [selectedOptions]="selectedEvaluationStatuses"
      (selectedOptionsChange)="onEvaluationStatusesChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <!-- Stato delivery -->
    <ape-multi-select
      *ngIf="deliveryStatusOptions.length>0"
      [id]="'delivery-status-filter'"
      [label]="TRANSLATION_KEYS.admin.monitoring.DELIVERY_STATUS | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.monitoring.SELECT_STATUSES | translate"
      [options]="deliveryStatusOptions"
      [selectedOptions]="selectedDeliveryStatuses"
      (selectedOptionsChange)="onDeliveryStatusesChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <!-- BU -->
    <ape-multi-select
      [id]="'bu-filter'"
      [label]="TRANSLATION_KEYS.admin.monitoring.BU | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.monitoring.SELECT_BU | translate"
      [options]="buOptions"
      [selectedOptions]="selectedBUs"
      (selectedOptionsChange)="onBUChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <!-- Office -->
    <ape-multi-select
      [id]="'office-filter'"
      [label]="TRANSLATION_KEYS.admin.monitoring.OFFICE | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.monitoring.SELECT_OFFICE | translate"
      [options]="officeOptions"
      [selectedOptions]="selectedOffices"
      (selectedOptionsChange)="onOfficeChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <!-- Department -->
    <ape-multi-select
      [id]="'department-filter'"
      [label]="TRANSLATION_KEYS.admin.monitoring.DEPARTMENT | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.monitoring.SELECT_DEPARTMENT | translate"
      [options]="departmentOptions"
      [selectedOptions]="selectedDepartments"
      (selectedOptionsChange)="onDepartmentChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <!-- Società -->
    <ape-multi-select
      [id]="'company-filter'"
      [label]="TRANSLATION_KEYS.admin.monitoring.COMPANY | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.monitoring.SELECT_COMPANY | translate"
      [options]="companyOptions"
      [selectedOptions]="selectedCompanies"
      (selectedOptionsChange)="onCompanyChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <!-- Valutatore -->
    <ape-multi-select
      [id]="'evaluator-filter'"
      [label]="TRANSLATION_KEYS.admin.monitoring.EVALUATOR | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.monitoring.SELECT_EVALUATOR | translate"
      [options]="evaluatorOptions"
      [selectedOptions]="selectedEvaluators"
      (selectedOptionsChange)="onEvaluatorChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    >
      <ng-template
        #optionTemplate
        let-option
      >
        <div class="flex flex-col justify-start items-start gap-1">
          <span class="text-base font-normal text-[#334155]">{{option.forename}} {{option.surname}}</span>
          <span class="text-sm font-normal text-[#334155]">{{option.email}}</span>
        </div>
      </ng-template>
    </ape-multi-select>

  </div>

  <!-- Actions Template -->
  <div class="flex flex-col justify-between items-center sm:flex-row sm:gap-0 gap-2">
    <ape-button
      [minWidth]="'182px'"
      [label]="cancelLabel | translate"
      [variant]="'primary'"
      [aspect]="'outline'"
      [size]="'large'"
      (buttonClick)="onCancelClick()"
    />
    <ape-button
      [minWidth]="'182px'"
      [label]="confirmLabel | translate"
      [variant]="'primary'"
      [aspect]="'fill'"
      [size]="'large'"
      (buttonClick)="onConfirmClick()"
    />
  </div>
</ape-drawer>